<template>
  <article id="BARRING_RESELLING_STATUS">
    <transition name="fade" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </article>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'BarringResellingProfileContainer',

  created() {
    // TODO: this.$webtrekk.viewPage('sperrprofile', 'authentication.common');
  },

  beforeDestroy() {
    this.reset();
  },

  methods: {
    ...mapActions('barring', ['reset']),
  },
};
</script>
